export default "__VITE_ASSET__d3ce7f8c__"